export const GEO_DATA = {
  GET_GEO_DATA: 'GET_GEO_DATA',
}
